import { DatePickerDate } from '../types';
import { ICinemaWeek } from '../interfaces/ICinemaWeek';
import { IDateToRender } from '../interfaces/IDateToRender';
import dayjs from 'dayjs';

export class CalendarUtils {

  public static getCinemaWeeksByDays(days: number, startDate: dayjs.Dayjs = dayjs()): ICinemaWeek[] {
    const cinemaWeeks: ICinemaWeek[] = [];

    for (let day = 0; day < days; day++) {
      const dateToRender = this.getDateToRender(
        dayjs(startDate).add(day, 'day'),
        true,
        false,
        false
      );

      if (dateToRender.isSunday) {
        cinemaWeeks.push(this.getCinemaWeek(dateToRender.date));
      }
    }

    return cinemaWeeks;
  }

  public static getDateToRender(
    date: dayjs.Dayjs,
    isCurrentMonth: boolean,
    isLastMonth: boolean,
    isNextMonth: boolean
  ): IDateToRender {
    return {
      date,
      isSunday: date.day() === 0,
      isCurrentMonth,
      isLastMonth,
      isNextMonth,
      isToday: date.format('DD MM YYYY') === dayjs().format('DD MM YYYY')
    };
  }

  public static getCinemaWeek(date: DatePickerDate): ICinemaWeek {
    let baseDate = dayjs(date);
    let day = baseDate.isoWeekday();

    if (day > 0 && day < 4) {
      baseDate = baseDate.subtract(day + 3, 'day');
    } else if (day !== 4 && day > 4 && day < 8) {
      baseDate = baseDate.subtract(day - 4, 'day');
    }

    const yearStart = baseDate.startOf('year').isoWeekday(4);
    const isBeforeYearStart = baseDate.isBefore(yearStart);

    const cinemaWeek: ICinemaWeek = {
      from: baseDate.startOf('day'),
      to: baseDate.add(6, 'day').startOf('day'),
      week: null
    };

    if (isBeforeYearStart) {
      cinemaWeek.week = baseDate.subtract(1, 'year').isoWeeksInYear();
    } else {
      cinemaWeek.week = baseDate.isoWeek();
    }

    return cinemaWeek;
  }
}
